import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { getPagingInfo, DEFAULT_BUTTON_COUNTS, BUTTON_BREAKPOINTS } from './utils.js';
import { PaginationComponent } from './ui-components.js';
import { WindowHelperWrapper } from '../../../utils/WindowHelper.js';
var Pagination = function Pagination(props) {
  var _props$activePage = props.activePage,
    defaultActivePage = _props$activePage === void 0 ? 1 : _props$activePage,
    _props$isBranded = props.isBranded,
    isBranded = _props$isBranded === void 0 ? false : _props$isBranded,
    isLoadingData = props.isLoadingData,
    maxButtons = props.maxButtons,
    onPageChange = props.onPageChange,
    windowOverride = props.windowOverride,
    _props$coreTable = props.coreTable,
    coreTable = _props$coreTable === void 0 ? false : _props$coreTable;
  var _useState = useState(defaultActivePage),
    _useState2 = _slicedToArray(_useState, 2),
    activePage = _useState2[0],
    setActivePage = _useState2[1];
  var _useState3 = useState(9),
    _useState4 = _slicedToArray(_useState3, 2),
    defaultButtonCount = _useState4[0],
    setDefaultButtonCount = _useState4[1];
  var windowHelper = useMemo(function () {
    return WindowHelperWrapper(windowOverride);
  }, [windowOverride]);
  var pagingInfo = getPagingInfo(props);
  var onButtonCountChange = useCallback(function (index) {
    setDefaultButtonCount(DEFAULT_BUTTON_COUNTS[index]);
  }, [setDefaultButtonCount]);
  useEffect(function () {
    var destroyWindowWatcher = windowHelper.watchBreakpoints(BUTTON_BREAKPOINTS, onButtonCountChange);
    return function () {
      destroyWindowWatcher();
    };
  }, []);
  var handleSelect = function handleSelect(newPage) {
    setActivePage(newPage);
    onPageChange(newPage);
  };
  if (pagingInfo.dataSize !== pagingInfo.totalCount && (isLoadingData || !pagingInfo.hasPagination)) {
    return null;
  }
  var siblingPagesRange = Math.max(0, maxButtons ? (maxButtons - 3) / 2 : defaultButtonCount);
  var currentPage = activePage > pagingInfo.pageCount ? pagingInfo.pageCount : activePage;
  return /*#__PURE__*/React.createElement(PaginationComponent, {
    currentPage: coreTable && defaultActivePage ? defaultActivePage : currentPage,
    hideFirstAndLastPageLinks: true,
    isBranded: isBranded,
    onChange: handleSelect,
    siblingPagesRange: siblingPagesRange,
    totalPages: pagingInfo.pageCount,
    coreTable: coreTable
  });
};
Pagination.displayName = "Pagination";
export { Pagination };